export const fieldWrapperClassName = "flex w-full flex-col gap-1.5";

export const fieldLabelRowClassName = "flex items-center justify-between gap-2";

export const fieldOptionalMarkerClassName = "text-muted-foreground text-xs/relaxed leading-tight";

export const fieldErrorClassName = "text-destructive flex items-center gap-1.5 text-xs/relaxed";
